import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CollectionRoutingModule } from './collection-routing.module';
import { CollectionComponent } from './collection.component';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { FilterComponent } from './filter/filter.component';
import { TagsComponent } from './tags/tags.component';
import { ProductAddonsComponent } from './product-addons/product-addons.component';
import { HomeProductComponent } from './home-product/home-product.component';
import { NgxBbnZvendoModule } from '@bbndev/ngx-bbn-zvendo';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
	declarations: [
		CollectionComponent,
		ProductDetailsComponent,
		FilterComponent,
		TagsComponent,
		ProductAddonsComponent,
		HomeProductComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		SharedModule,
		NgxBbnZvendoModule,
		CollectionRoutingModule
	]
})
export class CollectionModule { }
